import { useVisibleNavLinks } from "@/hooks/useVisibleNavLinks";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useLocale } from "next-intl";
import Link from "next/link";
import React from "react";

export default function MobileMenu({
  isMobileMenuOpen,
  toggleDropdown,
  openDropdown,
  setIsMobileMenuOpen,
}: {
  isMobileMenuOpen: boolean;
  toggleDropdown: (label: string) => void;
  openDropdown: string | null;
  setIsMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const locale = useLocale();
  const isArabic = locale === "ar";
  const navLinks = useVisibleNavLinks();

  return (
    <AnimatePresence>
      {isMobileMenuOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          className="lg:hidden bg-white border-t border-gray-200 shadow-lg"
        >
          <div className="container mx-auto px-6 py-6 space-y-6">
            {navLinks.map((link) => (
              <div key={link.to}>
                {link?.children ? (
                  <button
                    onClick={() => toggleDropdown(link.label_en)}
                    className="flex justify-between items-center w-full py-3 text-lg font-medium text-gray-800"
                  >
                    {isArabic ? link.label_ar : link.label_en}
                    {link?.children && (
                      <ChevronDown
                        className={`w-5 h-5 transition-transform ${
                          openDropdown === link.label_en ? "rotate-180" : ""
                        }`}
                      />
                    )}
                  </button>
                ) : (
                  <Link
                    href={link.to}
                    onClick={() => {
                      toggleDropdown(link.label_en);
                      setIsMobileMenuOpen(false);
                    }}
                    className="flex justify-between items-center w-full py-3 text-lg font-medium text-gray-800"
                  >
                    {isArabic ? link.label_ar : link.label_en}
                  </Link>
                )}

                <AnimatePresence>
                  {link?.children && openDropdown === link.label_en && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      className="overflow-hidden"
                    >
                      <div className="pl-6 py-3 space-y-3 border-l-2 border-gray-300">
                        {link?.children.map((child: any) => (
                          <Link
                            key={child.to}
                            href={child.to}
                            onClick={() => setIsMobileMenuOpen(false)}
                            className="block py-2 text-gray-600 hover:text-black transition"
                          >
                            {isArabic ? child.label_ar : child.label_en}
                          </Link>
                        ))}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}

            <Link href="/contact" onClick={() => setIsMobileMenuOpen(false)}>
              <button className="w-full py-3 bg-gray-900 text-white rounded-xl text-lg font-semibold">
                {isArabic ? "تواصل معنا الآن" : "Get In Touch"}
              </button>
            </Link>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
